import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Col, Form, Row, Stack } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { countryNames } from "../../../services/helper/CountryDataAction";
import axios from "axios";
import { toast } from "react-toastify";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import { StatusCode } from "../../../services/helper";
import {
  deleteLocationData,
  fetchBusinessProfileData,
  updateLocationData,
} from "../../../redux/slice/BusinessProfileSlice";
import DeleteConFirmationModal from "../../../components/Common/DeleteConFirmationModal";
import MapComponent from "../../../components/Common/MapComponent";
import { Autocomplete, TextField } from "@mui/material";
// import ValidationSchema from "../../../components/Common/ValidationSchema";

const LocationPopup = ({ isOpen, onClose, selectedLocation }) => {
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [removeId, setRemoveId] = useState([]);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  //Redux state
  const { status } = useSelector((state) => state.BUSINESSPROFILE);

  //Redux functions
  const dispatch = useDispatch();

  //Formik initial state
  const initialValues = {
    location_name: "",
    street: "",
    city: "",
    county: "",
    country: "",
    zip_code: "",
    business_email: "",
    email: "",
    telephone: "",
    country_code: "",
    contact_number: "",
    assigned_admin_id: "",
    assigned_approver_id: "",
    longitude: "",
    latitude: "",
  };

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: initialValues,
    // validationSchema: ValidationSchema.createLocation,
    onSubmit: async (values) => {
      const data = await getLatLongData(values.street);
      if (!data) {
        toast.error("Please enter a valid location");
        return;
      }

      const updatedValues = {
        ...values,
        longitude: data.lon,
        latitude: data.lat,
        location_id: selectedLocation._id,
      };
      const res = await dispatch(updateLocationData({ data: updatedValues }));
      if (res.payload.status === 200) {
        onClose();
        dispatch(fetchBusinessProfileData());
      }
      // navigate("/businessprofile");
      // },

      // try {
      //   const res = await dispatch(updateLocationData({ id: selectedLocation._id, data }));

      //   if (res && res.status === 200) {
      //     toast.success(res.data?.message);
      //     navigate("/businessprofile");
      //   } else {
      //     toast.error("Failed to update location data.");
      //   }
      // } catch (error) {
      //   toast.error("Failed to update location data.");
      //   console.error("Error updating location data:", error.message);
      // }
    },
  });

  useEffect(() => {
    const fetchLocationDetails = async () => {
      if (selectedLocation) {
        setValues({
          location_name: selectedLocation?.location_name ?? "",
          street: selectedLocation?.street ?? "",
          city: selectedLocation?.city ?? "",
          country: selectedLocation?.country ?? "",
          county: selectedLocation?.county ?? "",
          zip_code: selectedLocation?.zip_code ?? "",
          country_code: selectedLocation?.country_code ?? "",
          telephone: selectedLocation?.telephone ?? "",
          contact_number: selectedLocation?.telephone ?? "",
          email: selectedLocation?.business_email ?? "",
          assigned_admin_name: selectedLocation?.assigned_admin_name ?? "",
          assigned_approver_name:
            selectedLocation?.assigned_approver_name ?? "",
          assigned_admin_id: selectedLocation?.assigned_admin_id ?? "",
          assigned_approver_id: selectedLocation?.assigned_approver_id ?? "",
        });

        if (selectedLocation?.street) {
          fetchLocationSuggestions(selectedLocation?.street ?? "");
          try {
            const locationDetails = await fetchLocationByName(
              selectedLocation?.street ?? ""
            );
            setCurrentLocation(locationDetails[0]);
          } catch (error) {
            console.error("Error fetching location details:", error);
          }
        }
      }
    };

    fetchLocationDetails();
  }, [selectedLocation]);

  //Methods

  const getAddressByPostalCode = async (value) => {
    try {
      const countryCode = "GB";
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?postalcode=${value}&countrycodes=${countryCode}&format=json&addressdetails=1`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch data. Status: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.length > 0) {
        const city = data[0].address.city || data[0].address.state;
        const country = data[0].address.country;

        const address = [
          { name: "city", value: city },
          { name: "country", value: country },
          { name: "zip_code", value: value },
        ];

        for (let i = 0; i < address.length; i++) {
          handleChange({
            target: address[i],
          });
        }
      } else {
        console.error("No location data found in response.");
      }
    } catch (error) {
      console.error("Error fetching location:", error.message);
    }
  };

  const fetchLocationByName = async (input) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${input}`
      );
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const handleClose = () => {
    onClose();
    setLocationSuggestions([]);
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "street") {
      fetchLocationSuggestions(value);
    }
    if (name === "zip_code") {
      getAddressByPostalCode(value);
    }
    handleChange(e);
    setValues((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const removeUserHandler = async () => {
    if (removeId) {
      try {
        const res = await dispatch(deleteLocationData(removeId));
        if (res?.payload?.status === 200) {
          onClose();
        }
      } catch (error) {
        console.error("Failed to delete location:", error);
      }
    }
  };
  const deleteHandler = () => {
    if (selectedLocation?._id) {
      setRemoveId(selectedLocation._id);
      setDeleteConfirm(true);
      setModalConfirmTitle("Are you sure you want to delete this location?");
    }
  };

  const getLatLongData = async (locationName) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${locationName}`
      );

      if (response.data.length > 0) {
        return response.data[0];
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };

  const fetchLocationSuggestions = async (input) => {
    if (input.trim() === "") {
      setLocationSuggestions([]);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${input}`
      );
      setLocationSuggestions(response.data);
    } catch (error) {
      setLocationSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered size="xl">
      <Modal.Header closeButton className="justify-content-center">
        <Modal.Title className="fw-bold">Location Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} id="location-form" name="location-form">
          <Row className="row-gap-4">
            <Col xs={12} lg={6} xl={5} xxl={5}>
              <div>
                <Stack className=" row-gap-3">
                  <MapComponent
                    latitude={selectedLocation.latitude}
                    longitude={selectedLocation.longitude}
                  />
                  <div>
                    <h5 className="fw-bold m-0">
                      {selectedLocation.location_name}
                    </h5>
                    <hr />
                    <div className="d-flex justify-content-between flex-wrap gap-2">
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex">
                          <div className="top_map_text">
                            <b className="smallText">
                              <small>House Number and Street Name</small>
                            </b>
                            <p className="m-0 text-break">
                              {selectedLocation.street}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex top_map_text">
                          <div>
                            <b className="smallText">
                              <small>Country</small>
                            </b>
                            <p className="m-0 text-break">
                              {selectedLocation.country}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex top_map_text">
                          <div>
                            <b className="smallText">
                              <small>City/Town</small>
                            </b>
                            <p className="m-0 text-break">
                              {selectedLocation.city}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex top_map_text">
                          <div>
                            <b className="smallText">
                              <small>Post Code</small>
                            </b>
                            <p className="m-0 text-break">
                              {selectedLocation.zip_code}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="my-3" />
                    <div className="d-flex justify-content-between map_bottom_text flex-wrap gap-2">
                      <div className="top_map_text">
                        <b className="smallText">
                          <small>Email</small>
                        </b>
                        <p className="m-0 text-break">
                          {selectedLocation.business_email}
                        </p>
                      </div>
                      <div className="right_text top_map_text">
                        <b className="smallText">
                          <small>Contact</small>
                        </b>
                        <p className="m-0 text-break">
                          {selectedLocation.telephone}
                        </p>
                      </div>
                    </div>
                  </div>
                </Stack>
              </div>
            </Col>
            <div className="col-12 d-block d-md-none">
              <hr className="m-0" />
            </div>
            <Col xs={12} lg={6} xl={7} xxl={7}>
              <div className="row row-gap-3">
                <Form.Group
                  className="col-12"
                  controlId="formBasicLocationName"
                >
                  <Form.Control
                    type="text"
                    name="location_name"
                    value={values.location_name}
                    onChange={onChangeHandler}
                    onBlur={handleBlur}
                    placeholder="Location Name"
                    autoComplete="off"
                  />
                  {errors.location_name && touched.location_name && (
                    <p className="text-danger mt-1 mb-0">
                      {errors.location_name}
                    </p>
                  )}
                </Form.Group>
                <Form.Group
                  className="col-12"
                  controlId="formBasicStreetAddress"
                >
                  <Autocomplete
                    freeSolo
                    options={locationSuggestions}
                    getOptionLabel={(option) => option.display_name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.display_name === value?.display_name
                    }
                    loading={loading}
                    value={currentLocation}
                    onChange={(event, newValue) => {
                      setCurrentLocation(newValue);
                      setFieldValue("street", newValue?.name || "");
                      setFieldValue(
                        "display_name",
                        newValue?.display_name || ""
                      );
                      setFieldValue("latitude", newValue?.lat || "");
                      setFieldValue("longitude", newValue?.lon || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Street Address"
                        name="street"
                        onBlur={handleBlur}
                        onChange={onChangeHandler}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={`${option.lat}-${option.lon}`}>
                        {option.display_name}
                      </li>
                    )}
                  />
                  {errors.street && touched.street && (
                    <p className="text-danger mt-1 mb-0">{errors.street} </p>
                  )}
                </Form.Group>
                <Form.Group className="col-12" controlId="formBasicCity">
                  <Form.Control
                    type="text"
                    name="city"
                    value={values.city}
                    onChange={onChangeHandler}
                    onBlur={handleBlur}
                    placeholder="City"
                  />
                  {/* {errors.city && touched.city ? (
                  <p className="text-danger mt-1 mb-0">{errors.city} </p>
                ) : null} */}
                </Form.Group>
                <Form.Group className="col-12" controlId="formBasicCounty">
                  <Form.Control
                    type="text"
                    name="county"
                    value={values.county}
                    onChange={onChangeHandler}
                    onBlur={handleBlur}
                    placeholder="County"
                  />
                  {errors.county && touched.county && (
                    <p className="text-danger mt-1 mb-0">{errors.county} </p>
                  )}
                </Form.Group>
                <Form.Group className="col-12" controlId="formBasicCountry">
                  <Form.Select
                    aria-label="Default select example"
                    name="country"
                    onChange={onChangeHandler}
                    value={values.country}
                    onBlur={handleBlur}
                  >
                    <option value="" disabled className="option-title">
                      Country
                    </option>
                    {countryNames &&
                      countryNames.map((curElm, index) => (
                        <option value={curElm.label} key={index}>
                          {curElm.label}
                        </option>
                      ))}
                  </Form.Select>
                  {errors.country && touched.country && (
                    <p className="text-danger mt-1 mb-0">{errors.country} </p>
                  )}
                </Form.Group>
                <Form.Group className="col-12" controlId="formBasicZipCode">
                  <Form.Control
                    type="text"
                    name="zip_code"
                    onChange={onChangeHandler}
                    placeholder="Post Code"
                    value={values.zip_code}
                  />
                  {errors.zip_code && touched.zip_code && (
                    <p className="text-danger mt-1 mb-0">{errors.zip_code} </p>
                  )}
                </Form.Group>
              </div>
            </Col>
          </Row>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="text-center d-flex justify-content-end gap-3 align-items-center flex-wrap">
          <button
            className="btn btn-dark py-2 px-4"
            type="button"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            onClick={deleteHandler}
            className="btn-delete btn btn-danger px-4 py-2"
            type="button"
          >
            Delete
          </button>
          <button
            className="btn btn-primary px-4 py-2"
            type="submit"
            form="location-form"
          >
            {status === StatusCode.LOADING ? <ButtonLoader /> : "Save Changes"}
          </button>
          {deleteConfirm && (
            <DeleteConFirmationModal
              show={deleteConfirm}
              title={modalConfirmTitle}
              eventHandler={removeUserHandler}
              hide={() => setDeleteConfirm(false)}
            />
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default LocationPopup;
